<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { t } from "../../stores/translations";

  export let question;
  export let properties = {};

  export let selectedId: number;

  const dispatch = createEventDispatcher();

  /**
   * Set the selected value and dispatch the select event.
   *
   * @param answer
   */
  function select(answer) {
    dispatch("select", answer);
  }
</script>

<section>
  {#each question.answers as answer}
    <label class:selected={selectedId === answer.id}>
      <input
        type="radio"
        name={question.slug}
        class:selected={selectedId === answer.id}
        on:click={() => select(answer)}
      />
      {$t(`questions.${question.slug}.answers.${answer.slug}`)}
    </label>
  {/each}
</section>

<style lang="scss">
  @import "src/lib/styles/variables";
  @import "src/lib/styles/mixins";

  section {
    display: flex;
    flex-direction: column;

    & > label {
      position: relative;
      background-color: $color-secondary;
      color: $color-text;
      font-size: $font-size-medium;
      line-height: $font-size-extra-large;
      font-family: "Roboto";
      border-radius: 0.25rem;
      cursor: pointer;

      padding: 0.75rem 1rem 0.75rem 2.5rem;

      &:not(:last-of-type) {
        margin-bottom: 0.5rem;
      }

      &.selected {
        color: $color-white;
        background-color: $color-primary;
        font-weight: $font-weight-bold;
      }

      &.selected::after {
        background-color: $color-primary;
        height: 12px;
        width: 12px;
        border: none;
        left: 0.75rem;
      }

      &::after {
        display: block;
        background-color: $color-white;
        border: 1px solid $color-disabled;
        border-radius: 50%;
        content: "";
        position: absolute;
        opacity: 1;
        height: 20px;
        width: 20px;
        left: 0.5rem;
        top: 50%;
        transform: translateY(-50%);
      }

      &.selected::before {
        background-color: $color-white;
        display: block;
        content: "";
        width: 20px;
        height: 20px;
        position: absolute;
        border-radius: 50%;
        left: 0.5rem;
        top: 50%;
        transform: translateY(-50%);
      }

      & > input {
        height: 0;
        width: 0;
        position: relative;
        display: none;
      }
    }
  }

  @include desktop {
    section {
        gap: 0.5rem;

        & > label {
          line-height: 2.5rem;
        }
    }
  }
</style>
